/// <reference path='../../docs-and-forms.module.ts' />
/// <reference path='../../../userDefinedControls/add/addControl.modal.controller.ts' />
/// <reference path='../../../../../../typings/index.d.ts' />

module Meevo.Plugins.DocsAndForms {
    import AddControlModalController = Meevo.Plugins.UserDefinedControls.AddControlModalController;
    import ControlTypeEnum = Meevo.Model.ControlTypeEnum;
    import AppAreaEnum = Meevo.Model.AppAreaEnum;
    import FormTypeEnum = Meevo.Model.FormTypeEnum;

    export class DocsAndFormsAddControlModalController extends AddControlModalController {
        static $inject = [
            '$mdDialog',
            'meevo.plugins.userDefinedControls.userDefinedControlsService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService'
        ];

        private docsAndFormsModel: IDocsAndFormsModel;

        constructor(protected $mdDialog: ng.material.IDialogService,
                    protected userDefinedControlsService: Meevo.Plugins.UserDefinedControls.IUserDefinedControlsService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected modalService: Meevo.Components.Modal.IModalService) {
            super($mdDialog, userDefinedControlsService, busyService, dataService, modalService);

            this.controlTypes = {
                '0': {'number': ControlTypeEnum.CheckBox, 'name': 'LABEL_UDF_CHECK_BOX'},
                '1': {'number': ControlTypeEnum.DatePicker, 'name': 'LABEL_UDF_DATE'},
                '2': {'number': ControlTypeEnum.DropDown, 'name': 'LABEL_UDF_DROP_DOWN'},
                '3': {'number': ControlTypeEnum.ListBox, 'name': 'LABEL_UDF_DROP_LIST_BOX'},
                '4': {'number': ControlTypeEnum.Markup, 'name': 'LABEL_UDF_DROP_MARKUP'},
                '5': {'number': ControlTypeEnum.Radio, 'name': 'LABEL_UDF_DROP_RADIO_BUTTON'},
                '6': {'number': ControlTypeEnum.Signature, 'name': 'LABEL_UDF_DROP_SIGNATURE'},
                '7': {'number': ControlTypeEnum.Initials, 'name': 'LABEL_UDF_DROP_SIGNATURE_INITIALS'},
                '8': {'number': ControlTypeEnum.TextArea, 'name': 'LABEL_UDF_DROP_TEXT_AREA'},
                '9': {'number': ControlTypeEnum.TextBox, 'name': 'LABEL_UDF_DROP_TEXT_BOX'},
            };

            this.userDefinedControl.tab_TId = this.docsAndFormsModel.id as any;
        }

        createNewControl() {
            super.createNewControl();
                       
            this.isActive = true;
        }

        saveField() {
            this.userDefinedControl.tabTypeEnum = this.docsAndFormsModel.tabTypeEnum;
            this.userDefinedControl.appAreaEnum =
                this.userDefinedControl.appAreaEnum =
                this.docsAndFormsModel.tabTypeEnum === FormTypeEnum.Charts
                    ? AppAreaEnum.Charts
                    : (this.docsAndFormsModel.formFillTypeEnum === FormFillTypeEnum.OnlyOnce
                        ? AppAreaEnum.Client
                        : AppAreaEnum.DocsAndForms);
            return super.saveField();
        }

        public checkIfValid(): void {
            if (AddControlModalController.isFormType1(this.selectedControlType)) {
                if (this.checkItemsValidity(true)) {
                    this.saveField();
                }
            } else {
                this.saveField();
            }
        }

        requiredStateToggled() {
        }
    }

    angular.module('meevo.plugins.docsAndForms')
        .controller('meevo.plugins.docsAndForms.DocsAndFormsAddControlModalController', DocsAndFormsAddControlModalController);
}
